import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    marginTop: 12,
    flex: 1,
    maxWidth: 900,
    justifyContent: 'space-between',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: "center",
    alignSelf: "center"
  },

  listItem: {
    flex: 1,
   /*  flexDirection: "row", */
    alignItems: "center",
    justifyContent: "space-between",
    borderWidth: 0.5,
    borderColor: '#077A97',
    borderRadius: 4,
    paddingVertical: 8,
    /* width: '100%', */
    maxWidth: 360,
    minWidth: 280,
    marginBottom: 8,
    marginHorizontal:10,
    flexWrap: 'wrap',
  },
  /* btnContainer: {
   flex: 1, 
   marginTop: 25, 
   flexWrap:"wrap", 
  }, */
  itemTextSection: {
    flex: 1,
    marginHorizontal: 16,
  },
  textBold: {
    textAlign: 'center',
    color: '#077A97',
    fontWeight: '500',
    fontSize: 18,
    textTransform: 'uppercase'
  },
});

export default styles;